import BaseModel from "./BaseModel";

class AccountModel extends BaseModel {
    pathname = "api-b2b/v1/account";

    postSignin = (account, password) => {
        return this.post({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/signin`,
            params: {
                account_name: account,
                password: password,
            },
        });
    };

    postUpdateProfile = ({phone, gender, birth}) => {
        return this.post({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/profile`,
            params: {
                phone,
                gender,
                birth,
            },
        });
    };

    postCheckPrevPassword = ({password}) => {
        return this.post({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/password`,
            params: {
                password,
            },
        });
    };

    putChangePassword = ({password}) => {
        return this.put({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/password`,
            params: {
                new_password: password,
            },
        });
    };

    postFindEmail = (info) => {
        return this.post({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/emailfind`,
            params: info,
        });
    };

    postFindPassword = (email) => {
        return this.post({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/passwordfind`,
            params: {
                account_name: email,
            },
        });
    };

    getCourseList = () => {
        return this.get({
            path: `${this.pathname}/course`,
        });
    };
}
export default AccountModel;
